import { getLegSideByAction } from './getLegSideByAction'

/**
 * Determines the order-level direction (debit = BUY, credit = SELL) for an
 * order that pairs a single option leg with an equity leg — covered calls,
 * married puts, and the trades that close them.
 *
 * The debit/credit toggle is hidden for these orders, so the direction has to be
 * derived. It comes off the equity leg: the stock dominates the notional 100:1,
 * so buying stock always nets a debit and selling always nets a credit, whichever
 * way the option leg points. Deriving it from the option leg instead inverts the
 * side on every one of these orders.
 *
 * @param {number} equityAction - Action of the equity leg, or null/undefined
 *   when the order has no equity leg (or one whose action isn't chosen yet).
 * @param {number} optionAction - Action of the lone option leg, used as the
 *   fallback when there is no equity leg to read.
 * @returns {typeof orderLegSideEnum} 'BUY' for a net debit, 'SELL' for a net credit.
 */
export const getEquityPairedOrderSide = (equityAction, optionAction) =>
  getLegSideByAction(equityAction ?? optionAction)
